import React from "react";
import { Compass } from "lucide-react";

const Discover: React.FC = () => {
  return (
    <div className="flex-1 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center py-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
            <Compass className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Discover</h1>
          <p className="text-lg text-gray-600 mb-8">
            Explore and discover new IoT devices and services
          </p>
          <div className="bg-gray-50 rounded-lg p-8 border-2 border-dashed border-gray-300">
            <p className="text-gray-500">
              Discover page content coming soon...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discover;
